import { render, staticRenderFns } from "./Login2fa.vue?vue&type=template&id=16dadaaf&"
import script from "./Login2fa.vue?vue&type=script&lang=js&"
export * from "./Login2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16dadaaf')) {
      api.createRecord('16dadaaf', component.options)
    } else {
      api.reload('16dadaaf', component.options)
    }
    module.hot.accept("./Login2fa.vue?vue&type=template&id=16dadaaf&", function () {
      api.rerender('16dadaaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/login/Login2fa.vue"
export default component.exports